angular.module("ainapp")
    .controller("substituteProductController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Substitute Product";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }



            $scope.Init = function () {
                $scope.Recipe = {
                    ProductId: "",
                    AltProductId: "",
                }

                $scope.load = false;
                $scope.RecipeList = [];
            }
            $scope.Init();

            $scope.ProductAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.productInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };

            $scope.ProductAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.Recipe.Product = {};
                    $scope.Recipe.Product.Name = data.Name;
                    $scope.Recipe.Product.ProductCode = data.ProductCode;
                    $scope.Recipe.Product.Id = data.Id;
                    $scope.Recipe.ProductId = data.Id;
                    $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.ProductAutocompleteDataSource
            };

            $scope.ProductCodeAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "ProductCode",
                dataTextField: "ProductCode",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.Recipe.Product = {};
                    $scope.Recipe.Product.Name = data.Name;
                    $scope.Recipe.Product.ProductCode = data.ProductCode;
                    $scope.Recipe.Product.Id = data.Id;
                    $scope.Recipe.ProductId = data.Id;
                    $scope.$apply();
                    $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                },
                minLength: 2,
                dataSource: $scope.ProductAutocompleteDataSource
            };


            $scope.RProductAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.Recipe.AltProduct = {};
                    $scope.Recipe.AltProduct.Name = data.Name;
                    $scope.Recipe.AltProduct.ProductCode = data.ProductCode;
                    $scope.Recipe.AltProduct.Id = data.Id;
                    $scope.Recipe.AltProductId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.ProductAutocompleteDataSource
            };

            $scope.RProductCodeAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "ProductCode",
                dataTextField: "ProductCode",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.Recipe.AltProduct = {};
                    $scope.Recipe.AltProduct.Name = data.Name;
                    $scope.Recipe.AltProduct.ProductCode = data.ProductCode;
                    $scope.Recipe.AltProduct.Id = data.Id;
                    $scope.Recipe.AltProductId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.ProductAutocompleteDataSource
            };


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.ProductId = $scope.Recipe.ProductId;
                        MainService.ProductAlternativesInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "Product.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Product.ProductCode": {
                                type: "string",
                                editable: false,
                            },
                            "Product.BrandName": {
                                type: "string",
                                editable: false,
                            },
                            "AltProduct.Name": {
                                type: "string",
                                editable: false,
                            },
                            "AltProduct.ProductCode": {
                                type: "string",
                                editable: false,
                            },
                            "AltProduct.BrandName": {
                                type: "string",
                                editable: false,
                            },


                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },


                columns: [
                    {
                        field: "Product.Name",
                        title: "Product",
                        },
                    {
                        field: "Product.ProductCode",
                        title: "Code",
                        },
                    {
                        field: "Product.BrandName",
                        title: "Brand",
                        },

                    {
                        field: "AltProduct.Name",
                        title: "Product",
                        },
                    {
                        field: "AltProduct.ProductCode",
                        title: "Code",
                        },
                    {
                        field: "AltProduct.BrandName",
                        title: "Brand",
                        },


                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  ",
                        width: '80px'
                        },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }


            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteAlternativesById($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }

            $scope.Edit = function (data) {
                $scope.Recipe = data;
            }


            $scope.AddData = function () {
                if ($scope.Recipe.ProductId == "") {
                    toastr.warning("Select Product");
                } else if ($scope.Recipe.AltProductId == "") {
                    toastr.warning("Select Recipe Product");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.SaveProductAlternatives($scope.Recipe).then(function (response) {
                        if (response.data) {
                            toastr.success("Success");

                            $scope.Recipe.AltProductId = "";
                            $scope.Recipe.AltProduct = {};

                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            $scope.load = false;
                        } else {
                            toastr.error("Error");
                            $scope.load = false;
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }
            }

                }])
